// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__244K0","label":"styles_label__Qxcdv"};